import { createSelector } from 'reselect'
import { memoize } from 'lodash'

import API from '../../api/api'

// Note: prefixed - shiftManagersReducer shares the plain MANAGER(S)_* types and overwrote this list
const MANAGERS_LOAD = 'ORGANISATION_MANAGERS_LOAD'
const MANAGER_CREATE = 'ORGANISATION_MANAGER_CREATE'
const MANAGER_UPDATE = 'ORGANISATION_MANAGER_UPDATE'

const initialState = {
  managers: [],
}

const organisationManagersReducer = (state = initialState, action) => {
  switch (action.type) {
    case MANAGERS_LOAD:
      return {
        ...state,
        managers: action.managers,
      }
    case MANAGER_CREATE: {
      return {
        ...state,
        managers: [action.data, ...state.managers],
      }
    }
    case MANAGER_UPDATE: {
      return {
        ...state,
        managers: state.managers.map((manager) => {
          if (manager.id === action.data.id) {
            return action.data
          } else {
            return manager
          }
        }),
      }
    }
    default:
      return state
  }
}

export const fetchManagers = () => {
  return (dispatch) =>
    API.getAllManagers()
      .then((res) => {
        dispatch(loadManagers(res))
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const createManager = (data) => {
  return (dispatch) =>
    API.createNewManager(data)
      .then((res) => {
        dispatch({ type: MANAGER_CREATE, data: res })
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const updateManager = (data, id) => {
  return (dispatch) =>
    API.updateManagerData(data, id)
      .then((res) => {
        dispatch({ type: MANAGER_UPDATE, data: res })
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const loadManagers = (managers) => {
  return {
    type: MANAGERS_LOAD,
    managers,
  }
}

export const selectManagers = (state) => state.organisationManagers.managers

export const selectManagerById = createSelector(selectManagers, (managers) =>
  memoize((id) => {
    if (id === 'new') {
      return {
        user: {},
      }
    }
    return managers.find((manager) => manager.id === parseInt(id)) || managers[0] || { user: {} }
  }),
)

export default organisationManagersReducer
